/* eslint-disable import/prefer-default-export */
import { createState, useState } from "@hookstate/core";
import { Persistence } from "@hookstate/persistence";
import { CallSheetParticipantInput } from "../../graphql/generated/graphql";
import { ICallSheet } from "../config/interfaces";
import { rowsInitial } from "../helper/schedule";

const initialState: ICallSheet = {
  project_id: "",
  title: "",
  date: "",
  comment: "",
  time: "",
  category: "",
  location: [],
  creative_document: [],
  schedule: rowsInitial(),
  participant: [],
  unsaved: false,
  participantByCategory: [],
  assignedByCategory: [],
  deletedSchedule: [],
};

const callSheetState = createState(initialState);
callSheetState.attach(Persistence("callSheet"));

export const initialStateCallSheet = () => {
  callSheetState.set(initialState);
};

export const setUnSavedCallSheet = (unsaved: boolean) => {
  callSheetState.unsaved.set(unsaved);
};

export const setCategoryCallSheet = (category: string) => {
  callSheetState.category.set(category);
};

export const setIdCallSheet = (id: string) => {
  callSheetState.project_id.set(id);
};

export const setTitleCallSheet = (title: string) => {
  callSheetState.title.set(title);
};

export const setCommentCallSheet = (comment: string) => {
  callSheetState.comment.set(comment);
};

export const setDateCallSheet = (date: string) => {
  callSheetState.date.set(date);
};

export const setTimeCallSheet = (time: string) => {
  callSheetState.time.set(time);
};

export const setParticipantsCallSheet = (
  participants: CallSheetParticipantInput[]
) => {
  callSheetState.participant.set(participants);
};

export const setScheduleCallSheet = (schedule: any) => {
  callSheetState.schedule.set([...schedule]);
};

export const setParticipantByCategory = (participants: any[]) => {
  callSheetState.participantByCategory.set(participants);
};

export const setAssignedByCategory = (participants: any[]) => {
  callSheetState.assignedByCategory.set(participants);
};

export const setDeletedSchedule = (schedule: any) => {
  callSheetState.deletedSchedule.set(schedule);
};

export const useCallSheetState = () => useState(callSheetState);
